import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import { useState } from 'react';
import { Computer } from '@mui/icons-material';
import ToggleTheme from '../../Themes/ToggleTheme';
import { useThemeContext } from '../../Themes/ThemeContext';

const pages = [
    { name: 'Experiance', href: '/#Experiance' }, 
    { name: 'Projects', href: '/#Projects' }
];
const settings = [];

function Navbar() {
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [mouseOver, setMouseOver] = useState(false);
  const maxElevation = 24;
  const minElevation = 0;
  const { theme, setTheme } = useThemeContext();
  
  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const isDarkMode = theme.mode === 'dark';
  const elementBGColor = isDarkMode ? 'white' : 'black';
  return (
    <Box
        onMouseEnter={e => setMouseOver(true)}
        onMouseLeave={e => setMouseOver(false)}
    >
        <AppBar 
            position="static"
            elevation={minElevation}
            color="secondary"
            sx={{
                backgroundColor: "#00000000",
                border: "hidden",
            }}
        >
            <Container maxWidth="xl">
                <Toolbar disableGutters>
                <div href="/">
                    <Computer
                        sx={{
                            paddingRight: "0.5rem",
                            display: {
                                xs: "none",
                                md: "flex",
                                color: elementBGColor
                            }
                        }}
                    />
                </div>
                <Typography
                    variant="h6"
                    noWrap
                    component="a"
                    href="/"
                    sx={{
                        mr: 2,
                        display: { xs: 'none', md: 'flex' },
                        fontFamily: 'monospace',
                        fontWeight: 700,
                        letterSpacing: '.3rem',
                        color: elementBGColor,
                        textDecoration: 'none',
                    }}
                >
                    AD
                </Typography>
                <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>

                    <IconButton
                    size="large"
                    aria-label="account of current user"
                    aria-controls="menu-appbar"
                    aria-haspopup="true"
                    onClick={handleOpenNavMenu}
                    color="inherit"
                    >
                    <MenuIcon />
                    </IconButton>
                    <Menu
                    id="menu-appbar"
                    anchorEl={anchorElNav}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    keepMounted
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                    open={Boolean(anchorElNav)}
                    onClose={handleCloseNavMenu}
                    sx={{ display: { xs: 'block', md: 'none' } }}
                    >
                    {pages.map((page) => (
                        <MenuItem key={page.name} href={page.href} onClick={handleCloseNavMenu}>
                        <Typography sx={{ textAlign: 'center' }}>{page.name}</Typography>
                        </MenuItem>
                    ))}
                    </Menu>
                </Box>


                <div href="/">
                    <Computer
                        sx={{
                            paddingRight: "0.5rem",
                            display: {
                                xs: "flex",
                                md: "none",
                            }
                        }}
                    />
                </div>

                <Typography
                    variant="h5"
                    noWrap
                    component="a"
                    href="/"
                    sx={{
                        mr: 2,
                        display: { xs: 'flex', md: 'none' },
                        flexGrow: 1,
                        fontFamily: 'monospace',
                        fontWeight: 700,
                        letterSpacing: '.3rem',
                        color: elementBGColor,
                        textDecoration: 'none',
                    }}
                >
                    AD
                </Typography>
                <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                    {pages.map((page) => (
                    <Button
                        key={page.name} 
                        href={page.href} 
                        onClick={handleCloseNavMenu}
                        color="secondary"
                        sx={{ my: 2, color: elementBGColor, display: 'block' }}
                    >
                        {page.name}
                    </Button>
                    ))}

                    <ToggleTheme />
                </Box>

                {/* <Box sx={{ flexGrow: 0 }}>
                    <Tooltip title="Open settings">
                    <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                        <Avatar alt="A" src="/static/images/avatar/2.jpg" />
                    </IconButton>
                    </Tooltip>
                    <Menu
                    sx={{ mt: '45px' }}
                    id="menu-appbar"
                    anchorEl={anchorElUser}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    keepMounted
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    open={Boolean(anchorElUser)}
                    onClose={handleCloseUserMenu}
                    >
                    {settings.map((setting) => (
                        <MenuItem key={setting} onClick={handleCloseUserMenu}>
                        <Typography sx={{ textAlign: 'center' }}>{setting}</Typography>
                        </MenuItem>
                    ))}
                    </Menu>
                </Box> */}
                
                </Toolbar>
            </Container>
        </AppBar>
    </Box>
  );
}
export default Navbar;